// src/components/BankSelect.tsx
import React from "react";

type Props = {
  value: string;
  onChange: (v: string) => void;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  selectClassName?: string;
};

type BankOption = {
  value: string;
  label: string;
};

/**
 * 1원 계좌인증용 은행/증권 코드 목록
 * (클로바 1원인증 은행 코드 테이블 기반)
 */
const BANK_OPTIONS: BankOption[] = [
  // ---- 은행 ----
  { value: "002", label: "산업은행" },
  { value: "003", label: "기업은행" },
  { value: "004", label: "KB국민은행" },
  { value: "005", label: "KEB 하나은행(구 외환은행)" },
  { value: "007", label: "수협은행" },
  { value: "008", label: "수출입은행" },
  { value: "011", label: "농협은행" },
  { value: "020", label: "우리은행" },
  { value: "023", label: "SC 제일은행" },
  { value: "027", label: "한국씨티은행" },
  { value: "031", label: "대구은행" },
  { value: "032", label: "부산은행" },
  { value: "034", label: "광주은행" },
  { value: "035", label: "제주은행" },
  { value: "037", label: "전북은행" },
  { value: "039", label: "경남은행" },
  { value: "045", label: "새마을금고" },
  { value: "048", label: "신협" },
  { value: "050", label: "상호저축은행" },
  { value: "054", label: "HSBC" },
  { value: "055", label: "도이치은행" },
  { value: "057", label: "JP모간체이스" },
  { value: "060", label: "BOA" },
  { value: "061", label: "비엔피파리바은행" },
  { value: "062", label: "중국공상은행" },
  { value: "064", label: "산림조합" },
  { value: "071", label: "우체국" },

  { value: "088", label: "신한은행" },
  { value: "089", label: "K뱅크" },
  { value: "090", label: "카카오뱅크" },
  { value: "092", label: "토스뱅크" },

  // ---- 증권사 ----
  { value: "209", label: "유안타증권" },
  { value: "218", label: "현대증권" },
  { value: "230", label: "미래에셋증권" },
  { value: "238", label: "대우증권" },
  { value: "240", label: "삼성증권" },
  { value: "243", label: "한국투자증권" },
  { value: "247", label: "NH투자증권" },
  { value: "261", label: "교보증권" },
  { value: "262", label: "하이투자증권" },
  { value: "263", label: "HMC투자증권" },
  { value: "264", label: "키움증권" },
  { value: "265", label: "이베스트투자증권" },
  { value: "266", label: "SK증권" },
  { value: "267", label: "대신증권" },
  { value: "268", label: "아이엠투자증권" },
  { value: "269", label: "한화투자증권" },
  { value: "270", label: "하나대투증권" },
  { value: "278", label: "신한금융투자" },
  { value: "279", label: "동부증권" },
  { value: "280", label: "유진투자증권" },
  { value: "287", label: "메리츠증권" },
  { value: "290", label: "부국증권" },
  { value: "291", label: "신영증권" },
  { value: "292", label: "LIG투자증권" },
];

export default function BankSelect({
  value,
  onChange,
  label = "은행",
  required,
  disabled,
  className = "",
  selectClassName,
}: Props) {
  return (
    <div className={className}>
      <label className="mb-1 block text-sm font-medium text-slate-700">
        {label}
      </label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        disabled={disabled}
        className={selectClassName || "w-full rounded-xl border border-slate-300 bg-white px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-indigo-500 disabled:bg-slate-100"}
      >
        <option value="">은행을 선택하세요</option>
        {BANK_OPTIONS.map((b) => (
          <option key={b.value} value={b.value}>
            {b.label}
          </option>
        ))}
      </select>
    </div>
  );
}
